<template>
  <div>
    <div class="panel">
      <div class="title">
        浩顿医生库
      </div>
    </div>

    <div class="logo">
      <div class="left">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/hxl.png">
        <div class="value">
          我们的专有资源库：经过验证的医疗保健专业人员
        </div>
      </div>

      <div class="right">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png">
        <div class="value">
          横跨亚洲的战略联盟
        </div>
      </div>
    </div>

    <div class="Verification">
      <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/iconPhysician.png">
      </div>
      <div class="text">
        <div class="title">
          医生招募是根据您的研究需求量身定制的，问题设计旨在挖掘您需要听到的答案。

        </div>
        <div class="value">
          <div class="one">
            我们有一个严格的验证过程，以确保每个HCP小组成员是真实的，可靠的，可用的。

          </div>
          <div class="two">
            没有合适的人参与，一个项目是不可能成功完成的。招募成功不仅仅是追踪你的精确目标并说服他们参与你的学习。当研究人员与这些医生见面时，这些医生必须能够清楚地表达自己的观点，并且对该主题知识渊博。

          </div>
        </div>
      </div>
    </div>

    <!-- Picture of Doctors and/or Events -->
    <div class="picture">
      <div class="box" @click="$router.push('/cn/interview?source=physician')">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/interview.jpg">
        <div class="value">深入访谈</div>
      </div>
      <div class="box" @click="$router.push('/cn/focus?source=physician')">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/focusGroup.jpg">
        <div class="value">小组座谈会</div>
      </div>
      <div class="box">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/patientRecordForm.jpg">
        <div class="value">病人记录表格</div>
      </div>
      <div class="box" @click="$router.push('/cn/onlinesurvey?source=physician')">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/onlineSurvey.jpg">
        <div class="value">在线调查</div>
      </div>
      <div class="box">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/productTesting.jpg">
        <div class="value">产品测试</div>
      </div>
      <div class="box">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/onlineVulletinBoard.jpg">
        <div class="value">在线公告板</div>
      </div>
    </div>

    <!-- Asia Access -->
    <world-map />

    <!-- Download our Panel Book -->
    <cn-down-load />

    <!-- case study -->
    <cn-case-study />

  </div>
</template>

<script>
import { panelDownloads, getNewsList, getCustomerList, advertisementFlow } from "@/api/api";
import CnDownLoad from "@/components/cndownLoad";
import CnCaseStudy from "@/components/cncaseStudy";
import WorldMap from "@/components/sail";

export default {
  data() {
    return {
      caseList: [],
      downloadfile: "",
      url: "",
      downloadid: ""
    };
  },
  created() {
    this.getCustomerList();
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  components: { CnDownLoad, CnCaseStudy, WorldMap },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "physicians",
          source: "",
          information: "Products Physicians"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "physicians",
          source: this.$route.query.source,
          information: "Products Physicians"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    getCustomerList() {
      getCustomerList({
        pageSize: 4,
        pageIndex: 1,
        status: 1, //启用
        origin: 1, //前台
        isRecommend: 1, //是否推荐
        customerType: 1
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "查询案例分享失败");
          return;
        }
        this.caseList = res.datalist || [];
        this.allCount = res.allCount;
      });
    },
    toDetail(id) {
      this.$router.push({ name: "caseDetail", query: { id: id } });
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.panel {
  background-color: #2cb1e9;

  .title {
    padding: 50px 120px;
    color: #fff;
    font-size: 40px;
    font-weight: 700;
  }
}

.logo {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  padding: 0 120px;
  height: 450px;

  .value {
    margin-top: 65px;
  }

  .left,
  .right {
    width: 50%;
    padding: 0 5%;
    margin: 80px 0;
    font-size: 20px;

    img {
      height: 40%;
    }
  }

  .left {
    border-right: 1px dashed #000;

    .value {
    }
  }
}
.Verification {
  background-color: #fff;
  display: flex;
  padding: 50px 120px;
  justify-content: space-between;

  img {
    width: 320px;
    margin-top: 50px;
  }
  .text {
    width: 65%;
    .title {
      font-size: 30px;
      font-weight: 700;
      margin-bottom: 50px;
      color: #2cb1e9;
    }
    .value {
      font-size: 23px;
      & > * {
        margin-top: 20px;
      }
    }
  }
}
.picture {
  padding: 80px 230px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  .box {
    cursor: pointer;
    width: 27%;
    position: relative;
    margin-bottom: 30px;

    img {
      width: 100%;
    }

    .value {
      font-size: 23px;
      text-align: center;
      vertical-align: bottom;
      position: absolute;
      bottom: 0;
      background-color: #2cb1e9;
      color: #fff;
      line-height: 50px;
      width: 100%;
    }
  }
}

.casetitle {
  font-size: 40px;
  font-weight: 700;
  padding: 50px 120px 0 120px;
}

@media screen and (max-width: 576px) {
  .panel {
    .title {
      font-size: 80px;
    }
  }
  .logo {
    height: 1800px;
    .left,
    .right {
      width: 100%;
      border: none;
    }
    .left {
      img {
        width: 40%;
        height: 60%;
      }
    }
    .value {
      font-size: 80px;
    }
  }
  .text {
    .left,
    .right {
      margin: 100px 0;
      font-size: 40px;
    }
  }
  .Verification {
    img {
      width: 600px;
    }
    display: block;
    .text {
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }

  .picture {
    padding: 50px 130px;

    .box {
      width: 80%;

      .value {
        font-size: 80px;
        line-height: 200px;
      }
    }
  }

  .casetitle {
    font-size: 80px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 80% !important;

      .el-dialog__footer {
        .el-button {
          font-size: 35px;
        }
      }
    }
  }
}
</style>